/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Doc_Type_ManualInputs */

const en_doc_type_manual = /** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual / User Guide`)
};

const id_doc_type_manual = /** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manual / Panduan Pengguna`)
};

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const es_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const fr_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const de_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const ja_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const zh_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const ar_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const it_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const ru_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const pt_doc_type_manual = en_doc_type_manual;

/** @type {(inputs: Doc_Type_ManualInputs) => LocalizedString} */
const ko_doc_type_manual = en_doc_type_manual;

/**
* | output |
* | --- |
* | "Manual / User Guide" |
*
* @param {Doc_Type_ManualInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const doc_type_manual = /** @type {((inputs?: Doc_Type_ManualInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Doc_Type_ManualInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_doc_type_manual(inputs)
	if (locale === "es") return es_doc_type_manual(inputs)
	if (locale === "fr") return fr_doc_type_manual(inputs)
	if (locale === "de") return de_doc_type_manual(inputs)
	if (locale === "ja") return ja_doc_type_manual(inputs)
	if (locale === "zh") return zh_doc_type_manual(inputs)
	if (locale === "ar") return ar_doc_type_manual(inputs)
	if (locale === "id") return id_doc_type_manual(inputs)
	if (locale === "it") return it_doc_type_manual(inputs)
	if (locale === "ru") return ru_doc_type_manual(inputs)
	if (locale === "pt") return pt_doc_type_manual(inputs)
	return ko_doc_type_manual(inputs)
});